import type { PaymentShareWhitelistItemApi } from 'api-typings/users/users';
import type { PaymentShareWhitelistItem } from './payment-share-whitelist-items.model';

export function transformPaymentShareWhitelistItems(
  paymentShareWhitelistItem: PaymentShareWhitelistItemApi,
): PaymentShareWhitelistItem {
  return {
    id: paymentShareWhitelistItem.id,
    entityId: paymentShareWhitelistItem.entity_id,
    entityType: paymentShareWhitelistItem.entity_type,
  };
}
